import { Avatar } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useDashboardContext } from '../../../providers/contexts/Dashboard'
import { ASIAN_LANGUAGES, UserRole } from '../../../utils/constants'
import { ROUTES } from '../../../utils/constants/enum'
import { useLocalState } from '../../../utils/local-storage'

import { isCountryAssociatedWithBeautyHealthId } from '../../../utils/helper-functions'
import './user-profile.scss'

const UserProfile = () => {
    const { userData } = useDashboardContext((state) => ({
        userData: state.userData,
    }))

    const { pathname } = useLocation()
    const { t } = useTranslation()
    const [language] = useLocalState<string>('i18nextLng', true)
    const [displayName, setDisplayName] = useState<string>('')
    const [avatar, setAvatar] = useState<string>('')
    const [joiningYear, setJoiningYear] = useState<string>('')

    useEffect(() => {
        setJoiningYear(userData?.createDate?.split('-')[0] ?? '')
        if (
            userData?.userRole === UserRole.Provider &&
            isCountryAssociatedWithBeautyHealthId(userData?.country ?? '') &&
            userData.businessName
        ) {
            const business_name = userData?.businessName ?? ''
            setDisplayName(business_name)
            setAvatar(business_name.charAt(0))
        } else {
            if (language && ASIAN_LANGUAGES.includes(language)) {
                setDisplayName(`${userData?.lastName} ${userData?.firstName}`)
                setAvatar(`${userData?.lastName?.charAt(0)}`)
            } else {
                setDisplayName(`${userData?.firstName} ${userData?.lastName}`)
                setAvatar(`${userData?.firstName?.charAt(0)}`)
            }
        }
    }, [
        userData?.createDate,
        userData?.firstName,
        userData?.lastName,
        userData?.businessName,
        userData?.userRole,
        language,
    ])

    return (
        <>
            <div
                className={`user-profile ${
                    pathname !== ROUTES.DASHBOARD ? 'hide-mobile' : null
                }`}
            >
                <div className="profile">
                    <Avatar className="avatar-icon">{avatar}</Avatar>
                    <div className="profile-details">
                        <h2>{displayName ?? ''}</h2>
                        <p>
                            <span>
                                {t(
                                    'common_elements.business_inception_date_text'
                                )}{' '}
                                {joiningYear}
                            </span>
                            <span>
                                {userData?.userRole !== UserRole.Client &&
                                    ` | ${
                                        userData?.userRole === UserRole.Provider
                                            ? t(
                                                  'provider_dashboard_page.business_inception_user'
                                              )
                                            : t(
                                                  'esti_dashboard_page.business_inception_user'
                                              )
                                    }`}
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserProfile
